import { UserRound, Building2, Gavel, ArrowUpRight, Briefcase } from "lucide-react";
import { Reveal } from "../components/Reveal";
import { SectionTag } from "../components/SectionLabel";
import { waLink } from "../lib/whatsapp";

const SERVICES = [
  {
    slug: "empregados",
    icon: UserRound,
    title: "Para empregados",
    text: "Orientação e atuação para quem foi demitido, está em vias de ser ou precisa entender seus direitos.",
  },
  {
    slug: "empresas",
    icon: Building2,
    title: "Para empresas",
    text: "Defesa, prevenção e adequação trabalhista para reduzir risco e organizar a tomada de decisão.",
  },
  {
    slug: "advogados",
    icon: Gavel,
    title: "Para advogados",
    text: "Apoio estratégico em audiências, sustentações orais e processos sensíveis.",
  },
];

export const Services = () => (
  <section id="servicos" className="bg-cream-dark py-24 lg:py-32" data-testid="services-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <Reveal>
        <SectionTag icon={Briefcase} label="Como podemos ajudar" tone="teal" />
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-ink max-w-lg mb-14">
          Feito para cada lado da mesa.
        </h2>
      </Reveal>

      <div className="grid md:grid-cols-3 border-t border-l border-line">
        {SERVICES.map((s, i) => (
          <Reveal key={s.title} delay={0.15 + i * 0.1}>
            <div
              className="group h-full border-r border-b border-line p-8 lg:p-10 bg-cream hover:bg-teal-dark transition-colors duration-400"
              data-testid={`service-card-${i}`}
            >
              <s.icon size={28} className="text-teal-dark group-hover:text-cream transition-colors duration-400" />
              <h3 className="font-serif text-2xl mt-6 text-ink group-hover:text-cream transition-colors duration-400">
                {s.title}
              </h3>
              <p className="mt-3 text-sm text-ink-soft group-hover:text-cream/80 leading-relaxed transition-colors duration-400">
                {s.text}
              </p>
              <a
                href={waLink(`Olá! Gostaria de saber mais sobre atendimento ${s.title.toLowerCase()}.`)}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-6 inline-flex items-center gap-1.5 font-mono text-[11px] uppercase tracking-[0.15em] text-teal-dark group-hover:text-cream transition-colors duration-400"
                data-testid={`service-card-link-${s.slug}`}
              >
                Falar sobre isso
                <ArrowUpRight size={14} />
              </a>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
